import { useIntl } from 'react-intl'

/**
 * Returns a lookup of CruiseDurationOptions.name → localised label.
 * Shared between CruiseWhenSelectHowLong and CruiseSearchFiltersMobile.
 *
 * `intl.formatMessage` already caches by descriptor id, so no extra
 * memoisation is needed here.
 */
function useCruiseDurationLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    'Any duration': intl.formatMessage({
      id: '1+V+v57Py1',
      defaultMessage: 'Any duration',
      description: 'Filter chip label for selecting any cruise duration',
    }),
    '1 - 4 Nights': intl.formatMessage({
      id: 'bnvI6y/PwU',
      defaultMessage: '1 - 4 Nights',
      description: 'Filter chip label for short cruise stays of 1 to 4 nights',
    }),
    '5 - 8 Nights': intl.formatMessage({
      id: 'lINPu39KGc',
      defaultMessage: '5 - 8 Nights',
      description: 'Filter chip label for medium cruise stays of 5 to 8 nights',
    }),
    '9 - 14 Nights': intl.formatMessage({
      id: '7OoBxD0PFp',
      defaultMessage: '9 - 14 Nights',
      description: 'Filter chip label for long cruise stays of 9 to 14 nights',
    }),
    '15+ Nights': intl.formatMessage({
      id: '27gPyw9T/F',
      defaultMessage: '15+ Nights',
      description: 'Filter chip label for very long cruise stays of 15 or more nights',
    }),
  }
}

export default useCruiseDurationLabels
